import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { MemberService } from '../../services/jrni/member.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  calendarPageText;
  minDate;
  maxDate;
  selectedDate: Date;
  currentDate: Date;
  selectedService;
  selectedLocation;
  slots: [];
  selectedSlot;
  availableDays: any;
  component: String;
  bookingsLimit: String;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private servicesService: ServicesService,
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private basketService: BasketService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private memberService: MemberService
  ) { }

  routerGoBack() {
    this.router.navigate(['/services']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  ngOnInit() {
    this.scrollToTop();
    this.component = 'calendar';
    this.spinner.show();

    this.selectedDepartment = this.datastoreService.selectedDepartment;

    if (this.selectedDepartment) {
      this.departmentService.getLocation().then((selectedLocation) => {
        this.selectedLocation = selectedLocation;
        selectedLocation.extra.hasOwnProperty('calendar_page_title')
          ? (this.pageTitle = selectedLocation.extra.calendar_page_title)
          : (this.pageTitle = 'Calendar title not set');
        selectedLocation.extra.hasOwnProperty('calendar_page_text')
          ? (this.calendarPageText = selectedLocation.extra.calendar_page_text)
          : null;
      });

      let parentDepartment = this.datastoreService.parentDepartment;

      // this.selectedLocation = this.departmentService.getLocation();

      // Set the current date to today for the calendar to default to today
      this.currentDate = new Date();
      this.selectedDate = this.currentDate;

      // Retrieve the selected service
      this.servicesService.get().then((service) => {
        this.selectedService = service;

        // Clear the basket
        this.basketService
          .deleteAllBaskets(this.selectedDepartment)
          .catch((err) => {
            this.alertService.error(
              this.translateService.instant('COMMON.GENERAL_ERR')
            );
          });

        // // this.spinner.hide();
      });
    } else {
      this.restartJourney();
    }
  }

  continue() {
    this.alertService.clear();
    this.availabilityService.getSelectedSlot().then((slot) => {
      if (slot) {
        // Store the selected date
        this.datastoreService.selectedDate = this.selectedDate;
        // Store the selected slot
        this.datastoreService.selectedSlot = slot;
        this.router.navigate(['/booking-details']);
      } else {
        this.alertService.warn(
          this.translateService.instant('CALENDAR.SLOT_WARNING')
        );
        this.scrollToTop();
      }
    });
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
